import React from 'react';
import { PASOS_FIRMA } from './legalLabels';

function indiceDe(paso) {
  return PASOS_FIRMA.findIndex((p) => p.id === paso);
}

function LegalStepper({ paso, onPaso }) {
  const actual = indiceDe(paso);

  return (
    <ol className="legal-stepper">
      {PASOS_FIRMA.map((item, i) => {
        const esActual = i === actual;
        const esAnterior = i < actual;
        if (esAnterior) {
          return (
            <li key={item.id} className="legal-stepper-item is-done">
              <button type="button" onClick={() => onPaso(item.id)}>{item.label}</button>
            </li>
          );
        }
        return (
          <li
            key={item.id}
            className={`legal-stepper-item${esActual ? ' is-current' : ''}`}
            aria-current={esActual ? 'step' : undefined}
          >
            <span>{item.label}</span>
          </li>
        );
      })}
    </ol>
  );
}

export default LegalStepper;
